import * as React from "react"
import { type Contact } from "@digits-graphql/frontend/graphql-public"
import useRouter from "@digits-shared/hooks/useRouter"
import styled from "styled-components"
import { useCreatePasswordResetWithDelay } from "src/frontend/components/Session/Glow/PasswordReset/useCreatePasswordReset"
import { useGoToLogin } from "src/frontend/components/Session/Glow/PasswordReset/useGoToLogin"
import { UserInfo } from "src/frontend/components/Session/Glow/PasswordReset/UserInfo"
import { EmailNotification } from "src/frontend/components/Shared/Glow/EmailNotification"
import routes from "src/frontend/routes"

const StyledUserInfo = styled(UserInfo)`
  margin-bottom: 16px;
`

const COPY =
  "It looks like your password reset link has expired. To change your password, request a new reset link." as const

export const PasswordResetExpired: React.FC<{ contact?: Contact }> = ({ contact }) =>
  contact?.emailAddress ? (
    <PasswordResetExpiredContact contact={contact} />
  ) : (
    <PasswordResetExpiredNoContact />
  )

const PasswordResetExpiredContact: React.FC<{ contact: Contact }> = ({ contact }) => {
  const { loading, onClick, disabled } = useCreatePasswordResetWithDelay(contact.emailAddress)
  const onBack = useGoToLogin()
  return (
    <EmailNotification
      id="request-password-reset"
      onBack={onBack}
      onClick={onClick}
      title="Password Reset Expired!"
      buttonLabel="Resend Email"
      disabled={disabled || loading}
    >
      <StyledUserInfo contact={contact} />
      {COPY}
    </EmailNotification>
  )
}

const PasswordResetExpiredNoContact: React.FC = () => {
  const { history } = useRouter()
  const onClick = React.useCallback(() => {
    history.replace(routes.passwordReset.generate())
  }, [history])

  return (
    <EmailNotification
      id="to-password-reset"
      onClick={onClick}
      title="Password Reset Expired!"
      buttonLabel="Request Link"
    >
      {COPY}
    </EmailNotification>
  )
}
